import { CalculationResult } from '../types';
import { Badge } from './ui/badge';

interface Props {
  // For webapp2 (CalculationResult format)
  result?: CalculationResult;
  // For webapp (ResultsTable format)
  newProgramme?: boolean;
  jupas_id?: string;
}

export const NewBadge: React.FC<Props> = ({ newProgramme}) => {

  if (!newProgramme) return null;

  return (
    <Badge variant="green">
      New
    </Badge>
  );
};
